<template>
  <svg
    width="174"
    height="190"
    viewBox="0 0 174 190"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M134.78 0.410382C139.957 -1.29973 145.29 2.55471 145.29 8.00609V134.549C145.29 141.452 140.864 147.576 134.31 149.741L14.4512 189.34C7.33384 191.691 0.000236359 186.391 0 178.896V34.4797C0.000155745 27.3182 4.75939 21.0288 11.6514 19.0823L41.1143 10.761C47.3625 8.99627 53.581 11.4478 57.1464 16.1296C60.02 19.903 64.7922 23.5321 69.2958 22.0442L134.78 0.410382Z" fill="#D9D9D9"/>
    <mask
      id="mask0_115_2240"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="174"
      height="190"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M134.78 0.409842C139.957 -1.3003 145.29 2.55502 145.29 8.00652V31.5095L163.409 25.5241C169.412 23.541 175.235 28.9761 173.669 35.1012L147.459 137.631C146.108 142.916 142.156 147.149 136.977 148.86L134.341 149.73C134.33 149.734 134.32 149.738 134.31 149.742L14.4512 189.34C7.33373 191.692 0 186.391 0 178.895V34.4802C0 27.3185 4.75927 21.0292 11.6514 19.0827L41.1143 10.7614C47.3624 8.99674 53.581 11.4481 57.1465 16.1296C60.0202 19.9027 64.7925 23.5314 69.2959 22.0436L134.78 0.409842Z" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_115_2240)">
      <rect
        x="-17.0205"
        y="-29.5171"
        width="212.539"
        height="249.484"
        fill="#F3F3F3"
      />
      <g filter="url(#filter0_f_115_2240)">
        <ellipse
          cx="18.1677"
          cy="130.926"
          rx="147.153"
          ry="74.862"
          transform="rotate(9.98145 18.1677 130.926)"
          fill="#6FD689"
        />
      </g>
      <g filter="url(#filter1_f_115_2240)">
        <ellipse
          cx="10.1677"
          cy="146.926"
          rx="147.153"
          ry="74.862"
          transform="rotate(9.98145 10.1677 146.926)"
          fill="#53C7ED"
        />
      </g>
      <g filter="url(#filter2_f_115_2240)">
        <ellipse
          cx="10.1677"
          cy="170.926"
          rx="147.153"
          ry="74.862"
          transform="rotate(9.98145 10.1677 170.926)"
          fill="#0E2988"
        />
      </g>
      <path d="M29.8314 77.4213C31.1826 72.1359 35.1337 67.9032 40.3137 66.1918L163.409 25.524C169.412 23.5407 175.235 28.9763 173.669 35.1016L147.459 137.631C146.107 142.916 142.156 147.149 136.976 148.86L19.0866 187.808C10.8323 190.536 2.82552 183.062 4.97858 174.639L29.8314 77.4213Z" fill="url(#paint0_radial_115_2240)"/>
      <g filter="url(#filter3_f_115_2240)">
        <path d="M9.29004 64.7922C9.29004 57.6689 13.9992 51.4035 20.8416 49.423L130.356 17.7254C135.472 16.2445 140.58 20.0835 140.58 25.41V135.018C140.58 142.141 135.871 148.407 129.028 150.387L23.3483 180.975C16.3132 183.011 9.29004 177.733 9.29004 170.409V64.7922Z" fill="url(#paint1_radial_115_2240)" fill-opacity="0.3"/>
      </g>
      <path d="M79.3267 68.0312C89.9719 68.0313 98.602 76.6614 98.6021 87.3066V89.123C104.534 90.8016 108.881 96.2562 108.881 102.726V118.146C108.881 125.952 102.553 132.28 94.7466 132.28H63.9067C56.1003 132.28 49.7711 125.952 49.771 118.146V102.726C49.7714 96.2559 54.1185 90.8004 60.0513 89.1221V87.3066C60.0513 76.6614 68.6814 68.0313 79.3267 68.0312ZM79.3267 101.44C77.1977 101.44 75.4714 103.167 75.4712 105.296V115.576C75.4714 117.705 77.1977 119.431 79.3267 119.431C81.4554 119.43 83.1819 117.705 83.1821 115.576V105.296C83.1819 103.167 81.4554 101.441 79.3267 101.44ZM79.3267 75.7422C72.9396 75.7422 67.7623 80.9195 67.7622 87.3066V88.5898H90.8921V87.3066C90.892 80.9195 85.7138 75.7422 79.3267 75.7422Z" fill="url(#paint2_radial_115_2240)"/>
    </g>
    <defs>
      <filter
        id="filter0_f_115_2240"
        x="-178.747"
        y="1.48916"
        width="393.829"
        height="258.874"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="25.7" result="effect1_foregroundBlur_115_2240"/>
      </filter>
      <filter
        id="filter1_f_115_2240"
        x="-186.747"
        y="17.4892"
        width="393.829"
        height="258.874"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="25.7" result="effect1_foregroundBlur_115_2240"/>
      </filter>
      <filter
        id="filter2_f_115_2240"
        x="-186.747"
        y="41.4892"
        width="393.829"
        height="258.874"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="25.7" result="effect1_foregroundBlur_115_2240"/>
      </filter>
      <filter
        id="filter3_f_115_2240"
        x="0.290039"
        y="8.40479"
        width="149.29"
        height="182.011"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_115_2240"/>
      </filter>
      <radialGradient
        id="paint0_radial_115_2240"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(80.6281 -4.08371) rotate(91.4751) scale(150.073 158.733)"
      >
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </radialGradient>
      <radialGradient
        id="paint1_radial_115_2240"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(109.937 123.854) rotate(167.905) scale(82.8595 60.8456)"
      >
        <stop stop-color="#3489FE"/>
        <stop offset="1" stop-color="#3489FE" stop-opacity="0"/>
      </radialGradient>
      <radialGradient
        id="paint2_radial_115_2240"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-48.54 58.5282 -36.8452 -30.5561 108.881 62.0693)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </radialGradient>
    </defs>
  </svg>
</template>
<script setup lang="ts"/>
